import elements from "../../styles/settings/elements.module.scss";
import {Container} from "react-bootstrap";
import Jobs from "../../components/Jobs";

function AboutPage(){
    return(
        <Container className={`${elements.container} ${elements.about_page_container}`}>
            <h3 className={elements.section}>About me</h3>
            <hr className={elements.section_hr}/>

            <p>
                Software Engineer with 4+ years of full-stack experience building secure, scalable web applications.
                <br/>
                Led development of a startup marketplace, driving core infrastructure and API design, providing technical leadership, and solving complex engineering challenges. Built a database-driven AI assistant using OpenAI that accelerated user research by ~90%. Focused on maintainable code, performance, and reliable delivery.
            </p>

            {/*<Jobs/>*/}
        </Container>
    );
}

export default AboutPage;